import { render, staticRenderFns } from "./otcWallet.vue?vue&type=template&id=58514444&scoped=true&"
import script from "./otcWallet.vue?vue&type=script&lang=js&"
export * from "./otcWallet.vue?vue&type=script&lang=js&"
import style0 from "./otcWallet.vue?vue&type=style&index=0&id=58514444&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58514444",
  null
  
)

export default component.exports